export default {
  users: {
    userRemoved: 'کاربر حذف شد',
    userUpdated: 'کاربر به روز رسانی شد',
    userAdded: 'کاربر افزوده شد',
    user: 'کاربر',
    gender: 'جنسیت',
    fieldOfStudy: 'رشته تحصیلی',
    freeConsultation: 'نیازمند مشاوره رایگان هستم',
    birthDate: 'تاریخ تولد',
    newUser: 'کاربر جدید',
    nationalId: 'کد ملی',
    password: 'پسورد',
    passwordConfirm: 'تایید پسورد',
    mobileConfirmed: 'تایید موبایل',
    twoFactorEnabled: 'ورود دو مرحله ای',
    academicYear: 'سال تحصیلی',
    roles: 'نقش ها',
    parent: 'برای فرزندم ثبت نام میکنم',
    rolesInRealm: 'نقش ها در {name}',
    editUserRoles: 'ویرایش نقش های کاربر',
    userRolesUpdated: 'نقش های کاربر به روز رسانی شد',

    // Project
    bloodGroup: 'گروه خونی',
    drugs: 'داروهای مورد نیاز',
    heartDiseases: 'سوابق درمان',
    operationAreaAddress: 'محل جراحی',
    organization: 'سازمان',
    organizationCode: 'کد سازمان',
    relativePhone: 'شماره تماس بستگان',
    relativePhone1: 'شماره تماس بستگان 1',
    relativePhone2: 'شماره تماس بستگان 2',
    relativePhone3: 'شماره تماس بستگان 3',
    socialHabits: 'عادات اجتماعی',
    weight: 'وزن',
    legal: 'حقوقی',
    natural: 'حقیقی'
  }
}
